import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CacheConstant } from '../../../core/constants/app.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { PagedDataSource } from '../../models/paged-data-source';

@Component({
  selector: 'par-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  totalPages: number[] = new Array<number>();
  private _currentPage = 1;
  private _currentPageSize = 10;
  private _pagedDataSource = Array<any>();
  private _pageSizes: Array<number>;
  private _dataSource: Array<any>;
  envProperties = this.cache.get(CacheConstant.Env_Properties);
  elasticSearchFlag: boolean = this.envProperties.elasticSearchFlag ? this.envProperties.elasticSearchFlag.toBoolean() : false;

  get pageSizes(): Array<number> {
    return this._pageSizes;
  }

  @Input('pageSizes')
  set pageSizes(value: Array<number>) {
    this._pageSizes = value;
  }

  get currentPage(): number {
    return this._currentPage;
  }

  @Input('currentPage')
  set currentPage(value: number) {
    if (value && this._currentPage !== value) {
      this._currentPage = value;
      this.filterList();
      this.change.emit(this.setPagedDataSource());
    }
  }

  get currentPageSize(): number {
    return this._currentPageSize;
  }

  @Input('currentPageSize')
  set currentPageSize(value: number) {
    if (value && this._currentPageSize !== value) {
      this._currentPage = 1;
      this._currentPageSize = value;
      this.updatePaginator();
      this.filterList();
      this.change.emit(this.setPagedDataSource());
    }
  }

  get dataSource(): Array<any> {
    return this._dataSource;
  }

  @Input('dataSource')
  set dataSource(value: Array<any>) {
    if (value) {
      this._dataSource = value;
      this.updatePaginator();
    }
  }

  @Input() fullCatalogSearch: boolean;

  @Input() productSearchPageVO: any;

  @Output()
  change = new EventEmitter<PagedDataSource>();

  constructor(private cache: AppCacheService) {}

  ngOnInit() {
    this.filterList();
    this.updatePaginator();
  }

  onPaginationChange(pageIndex) {
    this._currentPage = parseInt(pageIndex);
    this.filterList();
    this.change.emit(this.setPagedDataSource());
  }

  onPageSizeChange(pageSize: number) {
    this._currentPageSize = pageSize;
    this.filterList();
    this.change.emit(this.setPagedDataSource());
  }

  setPagedDataSource(): PagedDataSource {
    const pagedDataSource = new PagedDataSource();
    pagedDataSource.currentPage = this._currentPage;
    pagedDataSource.currentPageSize = this._currentPageSize;
    if (this.fullCatalogSearch === undefined || this.fullCatalogSearch || !this.elasticSearchFlag) {
      pagedDataSource.dataSource = this._pagedDataSource;
    }
    return pagedDataSource;
  }

  private filterList() {
    let pageSize = Number(this._currentPageSize);
    this._pagedDataSource = new Array<any>();
    if (this._dataSource != undefined) {
      if (this._dataSource.length < this._currentPageSize) {
        pageSize = this._dataSource.length;
      }
      for (
        let i = (this._currentPage - 1) * pageSize;
        i < (this._currentPage - 1) * pageSize + pageSize;
        i++
      ) {
        if (i === this._dataSource.length) {
          break;
        }
        this._pagedDataSource.push(this._dataSource[i]);
      }
    }
  }

  private updatePaginator() {
    this.totalPages = new Array<number>();
    let recordCount;
    if (this._dataSource != undefined && this._dataSource.length > 0) {
      if (!this.fullCatalogSearch && this.productSearchPageVO && this.elasticSearchFlag) {
        recordCount = this.productSearchPageVO.total_results;
      }
      else {
        recordCount = this._dataSource.length;
      }
      for (
        let i = 1;
        i <= Math.ceil(recordCount / this._currentPageSize);
        i++
      ) {
        this.totalPages.push(i);
      }
    }
  }
}
